import { CHANGE_CALENDAR_ACTIVE_DATE } from "./actionTypes";

export default (activeDate) => ({
  type: CHANGE_CALENDAR_ACTIVE_DATE,
  payload: {
    activeDate // previous or next
  },
});